// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1MjgI","footer":"ReportModalFilter_footer__3lzFE"};